<template>
    <div v-if="isFullscreen"
         class="fullscreen-overlay"
         @click="toggleFullscreen">
    </div>
	
    <div :class="['fullscreen-wrapper', { fullscreen: isFullscreen }]">
	
        <div class="d-flex justify-content-between align-items-center"
           :style="{
                    padding: isFullscreen ? '.5rem' : '.1rem',
                    marginBottom: isFullscreen ? '5px' : '0',
                    backgroundColor: isFullscreen ? 'grey' : 'white',
                    position: isFullscreen ? 'sticky' : 'static',
                    zIndex: isFullscreen ? '99999' : '0',
                    top: isFullscreen ? '-20px' : null}">
        <h6 class="mb-0" :style="{color: isFullscreen ? 'white' : 'inherit'}">{{ title }}</h6>

        <button class="btn btn-sm" :class="{'btn-outline-primary' : !isFullscreen}" @click="toggleFullscreen">
          <template v-if="isFullscreen">
            <div style="position:sticky; top:0">
              <i class="bi bi-fullscreen-exit me-2"></i>
              <span>Wyjdź z trybu pełnego ekranu</span>
            </div>
          </template>
          <template v-else>
            <div>
              <i class="bi bi-fullscreen me-2 mb-2"></i>
              <span>Pełny ekran</span>
            </div>
          </template>
        </button>
      </div>
	  <div class="article-details-grid">
    <div class="detail">
      <div class="label">ID</div>
      <div class="value">{{ selectedArticle.article.id }}</div>
    </div>

    <div class="detail">
      <div class="label">Nr katalogowy</div>
      <div class="value">{{ selectedArticle.article.catalog_number }}</div>
    </div>

    <div class="detail">
      <div class="label">Model</div>
      <div class="value">{{ selectedArticle.article.model }}</div>
    </div>

    <div class="detail">
      <div class="label">Jednostka</div>
      <div class="value">{{ selectedArticle.article.article_unit?.name }}</div>
    </div>

    <div class="detail">
      <div class="label">Producent</div>
      <div class="value">{{ selectedArticle.article.producer?.id }}</div>
    </div>

    <div class="detail">
      <div class="label">Kategoria</div>
      <div class="value">{{ selectedArticle.article.customer_category?.name }}</div>
    </div>

    <div class="detail full">
      <div class="label">Opis</div>
      <div class="value">{{ selectedArticle.article.description }}</div>
    </div>

    <div class="detail full">
      <div class="label">Szczegóły</div>
      <div class="value">{{ selectedArticle.article.details }}</div>
    </div>

    <div class="detail">
      <div class="label">Utworzono</div>
      <div class="value">{{ formatDate(selectedArticle.article.created_at) }}</div>
    </div>

    <div class="detail">
      <div class="label">Utworzył</div>
      <div class="value">{{ selectedArticle.article.created_by?.name }}</div>
    </div>

    <div class="detail">
      <div class="label">Magazyn</div>
      <div class="value">{{ selectedArticle.article_warehouse?.short_name }}</div>
    </div>

    <div class="detail">
      <div class="label">Stan</div>
      <div class="value">{{ selectedArticle.article.stock_quantity }}</div>
    </div>

    <template v-if="hasPermission('canViewArticlesPricesAndHistory')">
      <div class="detail">
        <div class="label">VAT</div>
        <div class="value">{{ selectedArticle.article.vat }}%</div>
      </div>

      <div class="detail">
        <div class="label">Cena netto (PLN)</div>
        <div class="value">{{ selectedArticle.article.price_netto_zl }}</div>
      </div>

      <div class="detail">
        <div class="label">Cena brutto (PLN)</div>
        <div class="value">{{ selectedArticle.article.price_brutto_zl }}</div>
      </div>
    </template>

  </div></div>
</template>


<script>
import {Modal} from "bootstrap";
import {DatePickerComponent} from "@syncfusion/ej2-vue-calendars";
import {usePermission} from "../../composables/resources/js/composables/permissions.js";

let dropInstanceFilterUnits, delivererElem, multiSelectObj;


const {hasPermission} = usePermission();

export default {
  components: {
    "ejs-datepicker": DatePickerComponent,
    hasPermission
  },

  props: {
    selectedArticle: Object,
    statuses: Object
  },

  data() {
    return {
      hasPermission,
	  	isFullscreen: false

    }
  },

  methods: {
      toggleFullscreen() {
      this.isFullscreen = !this.isFullscreen;

      // opcjonalnie blokada scrolla dokumentu
      document.body.style.overflow = this.isFullscreen ? 'hidden' : '';
    },

    formatDate(dateString) {
      if (!dateString)
        return '';

      const date = new Date(dateString);
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0'); // Miesiące są od 0 do 11, więc dodajemy 1
      const year = date.getFullYear();

      return `${day}.${month}.${year}`;
    },
  }
}

</script>

<style scoped>
.article-details-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
  font-size: 13px;
}

.detail {
  border: 1px solid #dee2e6;
  border-radius: 4px;
  padding: 6px 8px;
  background: #fafafa;
}

.detail.full {
  grid-column: span 3;
}

.label {
  font-weight: 900;
  font-size: 14px;
  color: #495057;
  margin-bottom: 2px;
}

.value {
  font-size: 13px;
  color: #212529;
  word-break: break-word;
}

@media (max-width: 1200px) {
  .article-details-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .detail.full {
    grid-column: span 2;
  }
}

@media (max-width: 768px) {
  .article-details-grid {
    grid-template-columns: 1fr;
  }

  .detail.full {
    grid-column: span 1;
  }
}

/* Główny wrapper komponentu */
.fullscreen-wrapper {
  position: relative;
  transition: all .3s ease-in-out;
}

/* Tryb pełnoekranowy */
.fullscreen-wrapper.fullscreen {
  position: fixed;
  z-index: 1050;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  padding: 20px;
  background: #ffffff;
  overflow: auto;
  box-shadow: 0 0 40px rgba(0,0,0,.25);
  animation: fadeInFullscreen .2s ease-in-out;
}

/* Przyciemnione tło */
.fullscreen-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  z-index: 1049;
}

/* Delikatna animacja wejścia */
@keyframes fadeInFullscreen {
  from {
    opacity: 0;
    transform: scale(.98);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

</style>